var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/MC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/MC"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BoundingBox",
    points: "0 0 88 0 88 88 72.2089844 88 0 88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MC",
    transform: "translate(0.000000, 18.333333)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F79E1B",
    cx: 61.6,
    cy: 25.6666667,
    rx: 26.4,
    ry: 25.6666667
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#EB001B",
    cx: 26.4,
    cy: 25.6666667,
    rx: 26.4,
    ry: 25.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0009641,6.53637219 C49.4013989,11.2360885 52.8,18.0655095 52.8,25.6666667 C52.8,33.2678239 49.4013989,40.0972448 44.0009641,44.7969611 C38.5990209,40.0980883 35.2,33.2682932 35.2,25.6666667 C35.2,18.1537531 38.5201488,11.3947613 43.8117627,6.70091153 Z",
    id: "Combined-Shape",
    fill: "#FF5F00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMaster);
export default __webpack_public_path__ + "static/media/card-master.d00ee821fda7271a5f72dba985eabf92.svg";
export { ForwardRef as ReactComponent };